
import React from 'react'
import ChooseYourFlame from '../../components/flameSection';
import HeaderSection from '../../components/header';
import HeroSection from '../../components/herosection';

import TypeOfService from '../../components/servicesSection';

import Footer from '../../components/footerSection';

import ExpertSection from '../../components/ExpertSection';
import PartnershipSection2 from '../../components/partnershipSection2';
import TestimonialSection2 from '../../components/TestimonialSection2';

function Dashboard() {
 
  return (
    <div className="Dashboard">
      <HeaderSection/>
      <HeroSection/>
      <div className="height_black_container">
        
      </div>
      <ExpertSection />
      {/* <InformationSection /> */}
      <ChooseYourFlame />
      <TypeOfService />
      {/* <PartnershipSection /> */}
      <PartnershipSection2 />
      <TestimonialSection2 />
      {/* <TestionialSection  /> */}
      <Footer />
    </div>
  );
}

export default Dashboard;
